/**
 * 车辆类型
 */
 export const carType = [
    {value: 0, label: '临停' },
    {value: 1, label: '线上月卡' },
    {value: 2, label: '非机动车' },
    {value: 3, label: '线下月卡' }
]

/**
 * 车辆解绑状态
 */
 export const bindState = [
    {value: 0, label: '正常' },
    {value: 1, label: '已解绑' },
]

/**
 * 车主类型
 */
export const ownerType = [
    {value: 0, label: '业主' },
    {value: 1, label: '非业主' },
]
{/* <option value="1" selected>本小区业主</option>
<option value="2">本小区租赁户</option>
<option value="3">非小区业户</option>
<option value="0">车位产权人</option> */}

/**
 * 车辆状态
 */
export const carState = [
    {value: 0, label: '正常' },
    {value: 1, label: '停止' },
    {value: 2, label: '暂停' },
]

/**
 * 车辆审核状态
 */
export const auditState = [
    {value: -1, label: '审核未通过' },
    {value: 0, label: '待审核' },
    {value: 1, label: '审核已通过' },
]

/**
 * 支付状态
 */
export const payStatus = [
    {value: -1, label: '审核未通过' },
    {value: 2, label: '支付中' },
    {value: 5, label: '支付成功' },
]

/**
 * 订单是否需要确认
 */
export const needConfirm = [
    {value: 0, label: '无需确认' },
    {value: 1, label: '需确认' },
]
export default {
    carType,
    bindState,
    ownerType,
    carState,
    auditState,
    payStatus,
    needConfirm
}